<!-- prettier-ignore -->

<div class="chat__recommended">
  @if(dataChat.recommendedMessages().length > 0 && !dataChat.hasHistory()){
    @for( message of dataChat.recommendedMessages(); track $index ){
      <button class="chat__recommended-button" (click)="handleClick(message)">{{message}}</button>
    }
  }
  
</div>
